import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { Container, Row, Col } from "reactstrap";
import PopularProducts from "./PopularProducts";

import IronImage from "../Loading/IronImage";

import { filteringHomeScreen } from "../../actions/productAction";
import {
  getRaffleGroup,
  getRafflesToday,
  getUserRaffleTickets
} from "../../actions/kafairAction";
import { setCountDownModal } from "../../actions/menuAction";
import { sliderBanner, sliderItemClick } from "../../actions/slidersAction";
import { MODAL_SEARCH_TOGGLE } from "../../constants";

import KickCarousel from "./KickCarousel";
import EditorsCarousel from "./EditorsCarousel";
import BenefitFeatures from "./BenefitFeatures";
import ReleaseDate from "./ReleaseDate";
import FlashSale from "./FlashSale"
import GreenRaffle from "./GreenRaffle"
import KickFairContainer from "./KickFairContainer";
import NovembazarContainer from "./NovembazarContainer";
import InputSearch from "./InputSearch";
import { ASSET_IMAGE } from "../../config";
import Analytics from "../../services/Analytics";
import { LuxuryHome } from "./Luxury";
import HomepageContainer from "./HomepageContainer";
import moment from "moment"
import { joinClassnames } from "helpers/classNames";
import { doFetchMetadata } from "actions/metaAction";

const DURATION_FADE = 7000;

const brandsToFilter = [
  {
    name: "Jordan",
    params: "jordan".trim().replace(" ", "+"),
    title: "Jordan"
  },
  {
    name: "Browse All",
    params: "browse+all".trim().replace(" ", "+"),
    title: "Browse All"
  },
  {
    name: "NMD",
    params: "nmd".trim().replace(" ", "+"),
    title: "NMD"
  },
  {
    name: "Air Max",
    params: "air+max".trim().replace(" ", "+"),
    title: "Air Max"
  },
  {
    name: "Off-White",
    params: "off-white".trim().replace(" ", "+"),
    title: "Off-White"
  },
  {
    name: "Basketball",
    params: "basketball".trim().replace(" ", "+"),
    title: "Basketball"
  }
];

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSliders: [
        {
          src: `${ASSET_IMAGE}/sliders/24-5-2018-1.jpg`,
          altText: "Vapormax Acronym",
          href: "/search/vapormax+acronym",
          isLink: true
        },
        {
          src: `${ASSET_IMAGE}/sliders/24-5-2018-2.jpg`,
          altText: "Best Hand",
          href: "/search/best+hand",
          isLink: true
        },
        {
          src: `${ASSET_IMAGE}/sliders/24-5-2018-3.jpg`,
          altText: "Air Max Curry",
          href: "/search/air+max+curry",
          isLink: true
        }
      ],
      activeSlide: 0,
      pause: false,

      // meta tag implementation
      metaTitle: "",
      metaDescription: "",
    };
    this.raffleRef = React.createRef();
    this.flashSaleRef = React.createRef();
    this.hotProductsRef = React.createRef()
    this.ss21CollectionRef = React.createRef()
    this.kobe5Ref = React.createRef()
    this.nmdHuRef = React.createRef()
  }

  _handleActiveIndexChange(e, index) {
    e.preventDefault();
    if (this.state.intervalFunc) {
      clearInterval(this.state.intervalFunc);
    }
    this.setState(
      {
        activeSlide: index,
        intervalFunc: null
      },
      () => this._autoSlide()
    );
  }

  _autoSlide() {
    const intervalFunc = setInterval(() => {
      this.setState({
        activeSlide:
          (this.state.activeSlide + 1) % this.state.imageSliders.length
      });
    }, DURATION_FADE);
    this.setState({
      intervalFunc
    });
  }

  _toggleModalSearch(e) {
    e.preventDefault();
    const { modalSearchOpen } = this.props.dataProduct;
    this.props.toogleModalSearch(!modalSearchOpen);
  }

  _handleSliderClick(id) {
    const { dataAuth } = this.props;
    const payload = {
      slider_id: id,
      action: "SLIDER_ITEM_CLICK",
      user_id: dataAuth.isLogged ? dataAuth.userdata.id : null,
      app_os: "Web",
    };

    const sliderProperties = {
      userId: dataAuth.isLogged ? dataAuth.userdata.id : "Anonymous",
      app_os: "Web",
      slider_id: id
    };

    this.props.sliderItemClick(payload);
    Analytics.recordSliders("slider_item_click", sliderProperties);
  }

  handleFilterAction(id, name) {
    if (id === 0) {
      let params = name.replace(" ", "+");
      this.props.history.push(`/search/${params}`);
    } else {
      this.props.filteringHomeScreen(id);
    }
  }

  componentDidMount() {
    this._getSliderBanner();
    this._getMetaDatas();
  }

  async _getMetaDatas() {
    const data = await doFetchMetadata();
    const category = this.props.dataCategory;
    const page = this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1];

    const metaData = data.data.data.find((item: any) => item.page_url === page);
    if (!metaData) return;
    if (!metaData.active) return;

    this.setState({
      metaTitle: metaData.title,
      metaDescription: metaData.description,
    });
  }

  componentDidUpdate(prevProps) {
    const { scrollTo } = this.props;

    if (prevProps.dataCategory !== this.props.dataCategory) {
      this._getSliderBanner();
    }
    if (
      prevProps.sliderImages.isFetch !== this.props.sliderImages.isFetch &&
      !this.props.sliderImages.isFetch
    ) {
      this.setState({ pause: false });
    }

    if (prevProps.scrollTo !== scrollTo) {
      if (
        scrollTo === "FAIRGROUNDS" || scrollTo === "Raffle by BCA"
      ) {
        if (this.fairGroundSectionRef.current) {
          window.scrollTo({
            top: this.fairGroundSectionRef.current.offsetTop - 230,
            behavior: "smooth"
          });
        }
      }

      if (
        scrollTo === "BCA PROMO"
      ) {
        if (this.BcaPromoRef.current) {
          window.scrollTo({
            top: this.BcaPromoRef.current.offsetTop - 2000,
            behavior: "smooth"
          });
        }
      }

      if (scrollTo === "GOLD ZONE" || scrollTo === "HOLIDAY RAFFLE") {
        if (this.goldZoneRef.current) {
          window.scrollTo({
            top: this.goldZoneRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "RED ZONE") {
        if (this.redZoneRef.current) {
          window.scrollTo({
            top: this.redZoneRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "PURPLE ZONE") {
        if (this.purpleZoneRef.current) {
          window.scrollTo({
            top: this.purpleZoneRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (
        scrollTo === "INDONESIAN BRANDS" ||
        scrollTo === "Made in Indonesia"
      ) {
        if (this.indonesianBrandsRef.current) {
          window.scrollTo({
            top: this.indonesianBrandsRef.current.offsetTop - 100,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "MERCHANDISE") {
        if (this.officialMerchRef.current) {
          window.scrollTo({
            top: this.officialMerchRef.current.offsetTop - 150,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "SURPRISE DROP") {
        if (this.surpriseDropRef.current) {
          window.scrollTo({
            top: this.surpriseDropRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "EXCLUSIVE RELEASE") {
        if (this.exclusiveLaunchRef.current) {
          window.scrollTo({
            top: this.exclusiveLaunchRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "SNEAKERS") {
        if (this.sneakersSectionRef.current) {
          window.scrollTo({
            top: this.sneakersSectionRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      /**
       * @deprecated STREETWEAR is changed to FASHION
       */
      if (scrollTo === "STREETWEAR") {
        if (this.apparelsSectionRef.current) {
          window.scrollTo({
            top: this.apparelsSectionRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "APPAREL") {
        if (this.apparelsSectionRef.current) {
          window.scrollTo({
            top: this.apparelsSectionRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "LUXURY") {
        if (this.handbagsSectionRef.current) {
          window.scrollTo({
            top: this.handbagsSectionRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      /**
       * @deprecated LIFESTYLE is changed to TOYS
       */
      if (scrollTo === "LIFESTYLE") {
        if (this.lifestylesSectionRef.current) {
          window.scrollTo({
            top: this.lifestylesSectionRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "TOYS") {
        if (this.lifestylesSectionRef.current) {
          window.scrollTo({
            top: this.lifestylesSectionRef.current.offsetTop - 50,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "Kick Avenue Merchandise") {
        if (this.MerchandiseRef.current) {
          window.scrollTo({
            top: this.MerchandiseRef.current.offsetTop - 120,
            behavior: "smooth"
          });
        }
      }
      if (scrollTo === "Under Retail") {
        if (this.UnderRetailRef.current) {
          window.scrollTo({
            top: this.UnderRetailRef.current.offsetTop - 120,
            behavior: "smooth"
          });
        }
      }
    }

    if (
      prevProps.raffleGroup.isFetching &&
      !this.props.raffleGroup.isFetching &&
      !this.props.raffleGroup.error
    ) {
      const groups = this.props.raffleGroup.data
        ? this.props.raffleGroup.data.map(rg => rg.query)
        : [];
      groups.map(group_name => this.props.getRafflesToday(group_name));

      //FETCH CHILDREN RAFFLE
      const children = this.props.raffleGroup.data
        ? this.props.raffleGroup.data.map(item => item.children)
        : [];
      children.map(data => {
        if (data.length > 0) {
          this.props.getRafflesToday(data[0].query);
        }
      });
    }
  }

  _getSliderBanner = async () => {
    const { dataCategory } = this.props;
    const newCategory = dataCategory === "bcaxkickavenue" ? "bca" : dataCategory;
    const params = { params: { category: newCategory } };


    await this.setState({
      activeSlide: 0,
      pause: true
    });

    this.props.sliderBanner(params);
  };

  checkPathToDisplaySecretSantaEvent = () => {
    // if (moment().isBefore(moment(this.props.timer.start))) {
    //   setCountDownModal(false)
    //   return false
    // }
    if (moment().isAfter(moment(this.props.timer.end))) {
      return false;
    }
    return this.props.location.pathname === "/" ||
      this.props.location.pathname === "/sneakers" ||
      this.props.location.pathname === "/streetwear" ||
      this.props.location.pathname === "/fashion" ||
      this.props.location.pathname === "/apparel" ||
      this.props.location.pathname === "/luxury" ||
      this.props.location.pathname === "/lifestyle" ||
      this.props.location.pathname === "/toys" ||
      this.props.location.pathname === "/electronics-collectibles" ||
      this.props.location.pathname === "/madeindonesia"
      ? true
      : false;
  };

  _renderHomepage = () => {
    const { sliderImages, dataCategory, dataAuth } = this.props;
    return (
      <>
        <section>
          {sliderImages.images.length && !sliderImages.error ? (
            <KickCarousel
              activeIndex={this.state.activeSlide}
              pause={this.state.pause}
              sliders={sliderImages.images}
              sliderState={this.state.imageSliders}
              onActiveIndexChanged={index =>
                this.setState({ activeSlide: index })
              }
              dataAuth={dataAuth}
              history={this.props.history}
              onSliderClick={this._handleSliderClick}
            />
          ) : null}
          {dataCategory === "harbolnas" ? (
            <NovembazarContainer
              history={this.props.history}
              fairGroundRef={this.fairGroundSectionRef}
              goldZoneRef={this.goldZoneRef}
              redZoneRef={this.redZoneRef}
              purpleZoneRef={this.purpleZoneRef}
              indonesianBrandsRef={this.indonesianBrandsRef}
              officialMerchRef={this.officialMerchRef}
              surpriseDropRef={this.surpriseDropRef}
              exclusiveLaunchRef={this.exclusiveLaunchRef}
              sneakersSectionRef={this.sneakersSectionRef}
              apparelsSectionRef={this.apparelsSectionRef}
              handbagsSectionRef={this.handbagsSectionRef}
              lifestylesSectionRef={this.lifestylesSectionRef}
            />
          ) : (
            <>
              <EditorsCarousel />
              <BenefitFeatures category={dataCategory} />
              <ReleaseDate />
            </>
          )}
        </section>
        {dataCategory === "kafair" || dataCategory === "harbolnas" ? null : (
          <PopularProducts />
        )}
      </>
    )
  }

  render() {
    const { sliderImages, dataCategory, dataAuth, countdown_modal, timer } = this.props;
    const { metaDescription, metaTitle } = this.state;
    return (
      // <Container style={{ marginTop: this.checkPathToDisplaySecretSantaEvent() && timer.start && timer.end && countdown_modal && window.screen.availWidth > 480 ? "170px" : this.checkPathToDisplaySecretSantaEvent() && timer.start && timer.end && countdown_modal && window.screen.availWidth <= 480 ? "188px" : null }} fluid className="main-container" id="home-container">
      <Container fluid className={joinClassnames("main-container", countdown_modal ? 'countdown-active' : '')} id="home-container">
        {metaTitle !== '' && metaDescription !== '' && <Helmet>
          <title>{metaTitle}</title>
          <meta
            name="description"
            content={metaDescription}
            data-react-helmet="true"
          />
        </Helmet>}
        <HomepageContainer
          history={this.props.history}
          category={dataCategory}
        />
      </Container>
    );
  }
}


const WrapperPriceDropMobile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const WrapperBrowseAll = styled.div`
  position: relative;
  // box-shadow: 1px 1px 3px 2px #4a4a4a;
  &:hover {
    transform: scale(0.98);
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }
`;

const MarquestWrap = styled.div`
  position: absolute;
  bottom: 12px;
  text-align: center;
  font-family: "Nunito Bold";
  font-size: 16px;
  color: #fff;
  width: 100%;
  display: none;
  @media only screen and (min-device-width: 220px) and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    top: 9px;
    display: block;
  }
  @media only screen and (min-device-width: 321px) and (max-device-width: 375px) {
    display: block;
    top: 12px;
  }
  @media only screen and (min-device-width: 376px) and (max-device-width: 480px) {
    display: block;
    top: 14px;
  }
  /* Portrait and Landscape */
  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait) {
    display: block;
    top: 11px;
  }
`;

const mapStateToProps = state => ({
  dataProduct: state.dataProduct,
  sliderImages: state.sliderHome,
  dataCategory: state.dataCategory.selected,
  dataAuth: state.dataAuth,
  scrollTo: state.dataKaFair.scroll_to,
  raffle: state.dataKaFair.raffle,
  raffleGroup: state.dataKaFair.raffleGroup,
  countdown_modal: state.dataMenu.countdown_modal,
  timer: state.dataMenu.timer,
});

const mapDispatchToProps = dispatch => ({
  filteringHomeScreen: brandId => dispatch(filteringHomeScreen(brandId)),
  toogleModalSearch: payload =>
    dispatch({ type: MODAL_SEARCH_TOGGLE, payload }),
  sliderBanner: payload => dispatch(sliderBanner(payload)),
  getRafflesToday: payload => dispatch(getRafflesToday(payload)),
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  getRaffleGroup: () => dispatch(getRaffleGroup()),
  sliderItemClick: payload => dispatch(sliderItemClick(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
